import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BasePagingResponse } from "../_types";

export type GetMerchantUsageFeeRequestDto = {
    filters: [],
    page: number;
    size: number;
    orderBy: string;
    orderByDesc: boolean;
    status: string;
}

export type GetMerchantUsageFeeResponseDto = {
    merchantId?: number | null;
    merchantName?: string | null;
    selectedYear?: number | null;
    selectedMonth?: number | null;
    totalCount?: number | null;
    totalChargeAmount?: number | null;
    isComplated?: boolean | null;
    totalItems?: number | null;
    totalPages?: number | null;
}

export type GetMerchantUsageFeeResponsePaging = BasePagingResponse<Array<GetMerchantUsageFeeResponseDto>>;

async function getMerchantPOSUsageFee(
    data: GetMerchantUsageFeeRequestDto
): Promise<any> {
    try {
        return (await axiosInstance.post("/Merchant/GetMerchantUsageFee", data)).data;
    } catch (ex) {
        throw ((ex as AxiosError).response?.data as any).error;
    }
}

export function useGetMerchantPOSUsageFee() {
    return useMutation<GetMerchantUsageFeeResponsePaging, Error, GetMerchantUsageFeeRequestDto>((variables) =>
        getMerchantPOSUsageFee(variables)
    );
}
